module.exports = __webpack_public_path__ + "static/media/nyg.d2ba5618.png";